const wechatPay = {
  prepay: '/payment/weixinpay/mp/prepay',
}

export default wechatPay



// WEBPACK FOOTER //
// ./src/apis/services/wechatPay.js